// import { disciplineOptionValues } from "./data";

export const getFilteredText = (orgText) => {
  const pattern = /Original Text: (.*), Language: (.*), Discipline: (.*)/s; // 's' flag to handle multiline Original Text
  const match = orgText.match(pattern);
  if (match) {
    return match[1];
  } else {
    return orgText;
  }
};

// Function to get key by value
// export const getDisciplineKey = (value) => {
//     return Object.keys(disciplineOptionValues).find(
//         key => disciplineOptionValues[key] === value
//     );
// }

export const NOOP = () => {};

export const getGroupDisplayName = (group, index = 0, t) => {
  const candidates = [group?.name, group?.groupName];

  const explicitName = candidates.find(
    (value) => typeof value === "string" && value.trim()
  );

  if (!explicitName) {
    // No name → fallback
    return t ? t("group-label", { id: index + 1 }) : `Group ${index + 1}`;
  }

  const name = explicitName.trim();

  // ✅ Detect "Group X" pattern ONLY (system-generated)
  const match = name.match(/^Group\s+(\d+)$/i);

  if (match) {
    const groupNumber = Number(match[1]);

    // ✅ Translate instead of using raw backend string
    return t ? t("group-label", { id: groupNumber }) : name;
  }

  // ✅ Custom name → return as-is
  return name;
};

export const sortVoteEntries = (entries, sentinel = "-1") =>
  [...entries].sort((a, b) => {
    const [ka, va] = a,
      [kb, vb] = b;
    if (va !== vb) return vb - va;
    if (ka === sentinel && kb !== sentinel) return 1;
    if (kb === sentinel && ka !== sentinel) return -1;
    return (Number(ka) || 0) - (Number(kb) || 0);
  });
